import React from 'react';
import Fade from 'react-reveal/Fade';
import { useSite } from '../context/SiteContext';
import Skeleton from 'react-loading-skeleton';

export default function PartnersSection() {
  const { partners, loading } = useSite();
  const displayPartners = partners || [];
  
  return (
    <section className="waya-partners-wrapper py-5">
      <div className="container">
        <div className="text-center mb-5">
          <Fade bottom>
            <h6 className="waya-section-badge mx-auto">Our Ecosystem</h6>
            <h2 className="waya-section-title mt-3">Trusted by industry leaders</h2>
          </Fade>
        </div>

        <div className="waya-partners-grid mb-4">
          {loading ? (
            /* Skeleton Partners */
            // [1, 2, 3, 4, 5].map((i) => (
              <div className="waya-partner-item">
                <Skeleton width={100} height={40} />
              </div>
            // ))
          ) : (
            <>
              {displayPartners.map((p, idx) => (
                <div key={`p1-${idx}`} className="waya-partner-item">
                  {p.image_url ? (
                    <img src={p.image_url} alt={p.name} className="partner-logo"  />
                  ) : (
                    <div className="partner-placeholder">
                      <span>{p.name}</span>
                    </div>
                  )}
                </div>
              ))}
              {/* Duplicate for seamless marquee */}
              {displayPartners.map((p, idx) => (
                <div key={`p2-${idx}`} className="waya-partner-item d-md-none">
                  {p.image_url ? (
                    <img src={p.image_url} alt={p.name} className="partner-logo"  />
                  ) : (
                    <div className="partner-placeholder">
                      <span>{p.name}</span>
                    </div>
                  )}
                </div>
              ))}
            </>
          )}
        </div>
        
        <p className="text-center text-muted" style={{ fontSize: '13px', maxWidth: '600px', margin: '0 auto' }}>
      As part of the Wayalinks  ecosystem, Wayabank   connects people, businesses, and communities to the digital economy. From informal traders in Lagos to SMEs across the country, we are banking the unbanked, one account at a time.
        </p>
      </div>
    </section>
  );
}
